'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactBootstrap = require('react-bootstrap');
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/**
 * Component to allow you to trigger an overlay when the user e.g. hovers over the child component. (See also tooltip)
 */
var OverlayTrigger = function OverlayTrigger(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, ['children']);
  return _react2.default.createElement(_reactBootstrap.OverlayTrigger, rest, children);
};
var triggerType = _propTypes2.default.oneOf(['click', 'hover', 'focus']);
OverlayTrigger.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: _propTypes2.default.oneOfType([triggerType, _propTypes2.default.arrayOf(triggerType)]),
  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: _propTypes2.default.number,
  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: _propTypes2.default.number,
  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: _propTypes2.default.number,
  /**
   * An element or text to overlay next to the target.
   */
  overlay: _propTypes2.default.node.isRequired
} : {};
OverlayTrigger.defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus'],
  delayShow: 800
};
exports.default = OverlayTrigger;